import React from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import HorizontalStack from 'Components/ComponentLibrary/Atoms/Layout/HorizontalStack';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';
import WhatIfClientScenarioDetails from 'Components/ComponentLibrary/Organisms/WhatIfClientScenarioDetails';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import HeaderBar from 'Components/ComponentLibrary/Molecules/HeaderBar';
import ScenarioActions from './ScenarioActions';
import CommentsHeader from '../Components/CommentsHeader';
import { useCommentLayoutContext } from '../CommentLayoutProvider';
import Comments from './Comments';
import RightColumnPicker from './RightColumnPicker';
import FooterPicker from './FooterPicker';

const Content = () => {
  const isMobile = useMobileLayout();
  const { pageContentCollection, pageContentResource } = usePageContentContext();
  const { showCommentLayout } = useCommentLayoutContext();

  const showingMobileComments = isMobile && showCommentLayout;

  return (
    <HorizontalStack>
      <VerticalStack height={'screen'}>
        <StackItem hidden={!showingMobileComments} position={'top'}>
          <CommentsHeader />
        </StackItem>
        <StackItem scrollable fillsSpace hidden={showingMobileComments}>
          <WhatIfClientScenarioDetails
            facetPlanClientViewCollection={pageContentCollection}
            facetPlanClientViewResource={pageContentResource}
            header={<HeaderBar
              title="Scenario Selection"
              color={'black'}
              transparentBackground={false}
            />}
            callToAction={<ScenarioActions />}
          />
        </StackItem>
        <StackItem fillsSpace hidden={!showingMobileComments} />
        <StackItem scrollable hidden={!showingMobileComments}>
          <Comments />
        </StackItem>
        <StackItem fullWidth position={'bottom'}>
          <FooterPicker />
        </StackItem>
      </VerticalStack>
      <StackItem hidden={isMobile} unshrinkable>
        <RightColumnPicker />
      </StackItem>
    </HorizontalStack>
  );
};

export default Content;
